// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SHOW_ALL_FRIENDS = "Zobraz v\u0161echny";
